import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PublicRoutes from './PublicRoutes';
import { path } from '../constants';
// import AddressDetail from '../pages/Address/AddressDetails';

const Loader = lazy(() => import("../components/Loader"));
const Home = lazy(() => import("../pages/Home"));
const Blocks = lazy(() => import("../pages/Blocks"));
const SmartContracts = lazy(() => import("../pages/SmartContracts"));
const Transactions = lazy(() => import("../pages/Transaction"));
const BlockDetail = lazy(() => import("../pages/Blocks/BlockDetails"));
const SmartContractsDetails = lazy(() => import("../pages/SmartContracts/SmartContractsDetails"));
const PageNotFound = lazy(() => import("../pages/PageNotFound"));

const AppRoutes = () => {
  const LandingPage = () => {
    return <Navigate to={path.HOME} />;
  };

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route element={<PublicRoutes />}>
          <Route path={path.ROOT} element={<LandingPage />} />
          <Route path={path.HOME} element={<Home />} />
          <Route path={path.BLOCKS} element={<Blocks />} />
          <Route path={path.TRANSACTION} element={<Transactions />} />
          <Route path={path.SMART_CONTRACT} element={<SmartContracts />} />
          <Route path={`${path.BLOCKS}/:id?`} element={<BlockDetail />} />
          <Route path={`${path.SMART_CONTRACT}/:id?`} element={<SmartContractsDetails />} />
          {/*<Route path={`${path.ADDRESS}/:id`} element={<AddressDetail />} />*/}
          {/* <Route path={`${path.ADDRESS}`} element={<PageNotFound />} /> */}
          <Route path={path.PAGE_NOT_FOUND} element={<PageNotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
};
export default AppRoutes;
